<template>
  <div class="page page-industry">
    <section class="section">
      <div class="section-inner">
        <div class="section-header">
          <h2 class="section-title">行业资讯</h2>
          <p class="section-subtitle">聚焦行业前沿，分享客户实践与产品动态。</p>
        </div>
        <div class="news-list">
          <article
            v-for="item in news"
            :key="item.id"
            class="news-card"
            @click="goDetail(item.id)"
          >
            <div class="thumb-wrapper">
              <img :src="item.cover || 'https://picsum.photos/420/240?random=' + item.id" :alt="item.title">
            </div>
            <div class="news-content">
              <h3 class="news-title">{{ item.title }}</h3>
              <div class="news-meta">
                <span>{{ item.date }}</span>
                <span>· {{ item.author }}</span>
                <span>· 阅读量：{{ readCount(item.id) }}</span>
              </div>
              <p class="news-summary">{{ item.summary }}</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'IndustryPage',
  computed: {
    ...mapGetters(['getIndustryList', 'getIndustryReadCount']),
    news() {
      return this.getIndustryList
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/industry/${id}`).catch(() => {})
    },
    readCount(id) {
      return this.getIndustryReadCount(id)
    }
  }
}
</script>

<style scoped>
.page {
  background: #f4f8fc;
}

.news-list {
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.news-card {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 0;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.news-card:last-child {
  border-bottom: none;
}

.news-card:hover {
  background: #e0f2fe;
}

.thumb-wrapper {
  border-right: 1px solid #e5e7eb;
}

.thumb-wrapper img {
  width: 100%;
  height: 100%;
  min-height: 150px;
  object-fit: cover;
}

.news-content {
  padding: 18px 20px;
}

.news-title {
  font-size: 18px;
  color: #1e293b;
  margin-bottom: 8px;
  font-weight: 700;
}

.news-meta {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 10px;
}

.news-summary {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.8;
}

@media (max-width: 768px) {
  .news-card {
    grid-template-columns: 1fr;
  }

  .thumb-wrapper {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .thumb-wrapper img {
    height: 160px;
  }
}
</style>
